<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div>
                    <div class="content">
                        <h1>Privacybeleid</h1>
                        <p><strong>Privacyverklaring</strong></p>

                        <p>Deze Privacyverklaring geeft een beschrijving van de persoonsgegevens die worden verzameld en/of verwerkt binnen Brabant-Tools en is volledig opgesteld aan de hand van de Algemene Verordening Gegevensbescherming.</p>

                        <ol>
                            <li><strong>Privacybeleid</strong></li>
                            <p>Brabant-Tools hecht veel waarde aan het zorgvuldig gebruiken en verwerken van persoonsgegevens. De persoonsgegevens worden om deze reden dan ook zorgvuldig verwerkt en beveiligd, met de Algemene Verordening Gegevensbescherming als uitgangspunt.</p>

                            <p>In deze Privacyverklaring wordt daarom duidelijk vermeld:</p>

                            <ul>
                                <li>Voor welke doeleinden wij persoonsgegevens verwerken;</li>
                                <li>Hoe wij het verzamelen van persoonsgegevens beperken tot het doel waarvoor ze worden verwerkt;</li>
                                <li>Persoonsgegevens niet doorgeven aan derden, tenzij dit nodig is om de gevraagde diensten/producten te kunnen leveren of wanneer wij daartoe wettelijk verplicht zijn;</li>
                                <li>Er afspraken met derden zijn gemaakt, zodat ook zij op de juiste wijze om gaan met de persoonsgegevens;</li>
                                <li>Dat wij passende (beveiligings-)maatregelen hebben getroffen om de persoonsgegevens op een juiste wijze te beschermen;</li>
                                <li>Uw rechten respecteren en u ook graag op deze rechten willen wijzen.</li>
                            </ul>
                            <br />

                            <p>Als u naar aanleiding van deze Privacyverklaring contact met ons op wilt nemen, dan kan dat via onderstaande contactgegevens:</p>

                            <p>
                                Brabant-Tools<br />
                                Draaiboom 51<br />
                                5094 CB Lage Mierde<br />
                                +31 (0)497-701301<br />
                                info@brabanttools.nl<br />
                            </p>
                            <br />

                            <li><strong>Persoonsgegevens</strong></li>
                            <p>Persoonsgegevens en/of debiteurgegevens worden bij Brabant-Tools geregistreerd zodra producten bij ons worden afgenomen. Afhankelijk van welke gegevens benodigd zijn voor een goede uitvoering van de gevraagde service/diensten worden persoonsgegevens verwerkt:</p>

                            <ul>
                                <li>(Voor)na(a)m(en)</li>
                                <li>(Zakelijk) e-mailadres</li>
                                <li>(Zakelijk) telefoonnummer</li>
                                <li>Achternaam</li>
                                <li>Bedrijfsgegevens</li>
                                <li>Bedrijfsnaam</li>
                                <li>Curriculum Vitae</li>
                                <li>Functie</li>
                                <li>Geboortedatum</li>
                                <li>Gegevens over het gebruik van onze producten</li>
                                <li>Geslacht</li>
                                <li>IBAN</li>
                                <li>Inloggegevens</li>
                                <li>Leeftijd</li>
                                <li>Motivatiebrief</li>
                                <li>NAW-gegevens</li>
                                <li>Opleidingsniveau</li>
                                <li>Technische meetgegevens van apparatuur, zoals IP-adres, cookies en het surfgedrag op onze website.</li>
                                <li>Website</li>
                            </ul>
                            <br />

                            <li><strong>Doeleinden</strong></li>
                            <p>De bovenstaande gegevens worden verwerkt voor één of meer van de volgende doeleinden (afhankelijk van de doeleinden waarvoor de persoonsgegevens zijn verstrekt):</p>

                            <ul>
                                <li>Om de mogelijkheid te bieden om producten bij ons te bestellen;</li>
                                <li>Om een order te verwerken en u te informeren over de afwikkeling hiervan;</li>
                                <li>Om u te informeren over aanbiedingen, acties of algemene informatie met betrekking tot de producten/diensten van Brabant-Tools, door middel van automatische e-mails of post;</li>
                                <li>Om (open)sollicitaties te verwerken;</li>
                                <li>Om klachten over een product/dienst of het bedrijf te verwerken en het verloop en de afwikkeling hiervan terug te koppelen;</li>
                                <li>Om bestelde producten op het door u aangegeven adres af te leveren.</li>
                            </ul>
                            <br />

                            <li><strong>Verstrekking aan derden</strong></li>
                            <p>De verstrekte persoonsgegevens worden uitsluitend verstrekt aan derden indien dit noodzakelijk is voor het leveren van bestelde producten of service. Naast ons eigen vervoer wordt bijvoorbeeld gebruik gemaakt van externe partijen, welke zorgdragen voor de aflevering van producten.</p>
                            <p>Er worden duidelijke afspraken (door middel van een overeenkomst) afgesloten met derden, waar wij de persoonsgegevens mee delen. De persoonsgegevens worden verwijderd als deze niet meer worden gebruikt. De gegevens worden niet verstrekt aan partijen als dit niet noodzakelijk of wettelijk verplicht is.</p>
                            <br />

                            <li><strong>Beveiligen en bewaren</strong></li>
                            <p>Wij nemen passende (beveiligings-)maatregelen om misbruik en ongeautoriseerde toegang tot de persoonsgegevens tot een minimum te beperken. Alleen de noodzakelijke personen hebben toegang tot de gegevens. Wij bewaren de gegevens niet langer dan noodzakelijk, dan wel wettelijk toegestaan is.</p>
                            <br />

                            <li><strong>Rechten</strong></li>
                            <p>In het kader van de Algemene Verordening Gegevensbescherming heeft u recht op inzage, rectificatie of verwijdering van de persoonsgegevens en tevens kunt u bezwaar maken tegen het verwerken van de persoonsgegevens. De gegevens kunnen op uw verzoek worden overgedragen aan externe partijen.</p>
                            <br />

                            <li><strong>Autoriteit Persoonsgegevens</strong></li>
                            <p>Indien u klachten heeft over de verwerking van de persoonsgegevens kunt u uiteraard altijd contact met ons opnemen. Op grond van de Privacywetgeving kunt u ook een klacht indienen bij de privacy toezichthouder, de Autoriteit Persoonsgegevens.</p>
                            <br />

                            <p>
                                Brabant Tools BV<br />
                                Draaiboom 51<br />
                                5094 CB Lage Mierde<br />
                                +31 (0)497-701301<br />
                                info@brabanttools.nl<br />
                            </p>
                        </ol>

                    </div>
                </div>
            </div>
        </div>
        <bt-footer />
    </div>
</template>

<script>
    import BtFooter from './BTFooter.vue'

    export default {
        name: 'Privacy',
        data() {
            return {
            }
        },
        created() {
            document.title = 'Brabant-Tools | Privacy'
        },
        components: {
            BtFooter
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
